export default __webpack_public_path__ + "static/shrot_movie1_compressed-64bde530801a83683c238cf232201bb4.mp4";